import React from 'react'
import {
  Hero,
  PrismicSlices,
  Divider,
  HeroSlice,
  DividerSlice,
  OneColumn,
  OneColumnSlice,
  TwoColumnsSlice,
  TwoColumns,
  FeaturedListSlice,
  FeaturedList,
  ThreeColumnsSlice,
  ThreeColumns,
  ProductGridSlice,
  ProductGrid
} from 'modules/prismic'

interface Props {
  slice: PrismicSlices
}

export const SliceResolver = ({ slice }: Props) => {
  const { slice_type: type } = slice

  switch (type) {
    case 'hero':
      return <Hero {...(slice as HeroSlice)} />

    case 'divider':
      return <Divider {...(slice as DividerSlice)} />

    case 'one_column':
      return <OneColumn {...(slice as OneColumnSlice)} />

    case 'two_columns':
      return <TwoColumns {...(slice as TwoColumnsSlice)} />

    case 'three_columns':
      return <ThreeColumns {...(slice as ThreeColumnsSlice)} />

    case 'featured_list':
      return <FeaturedList {...(slice as FeaturedListSlice)} />

    case 'product_grid':
      return <ProductGrid {...(slice as ProductGridSlice)} />

    default:
      return null
  }
}
